module.exports = __webpack_public_path__ + "images/category_lp/game_console/store_images/5_e570c045599ec256cac36f44ae7a1220.png";